import { BaseModel } from './base';
import { User } from './User';

export type AttendanceRecordStrState = 'present' | 'absent' | 'late-excused' | 'late-not-excused' | 'not-selected';
export enum AttendanceRecordState {
	Present = 'present',
	Absent = 'absent',
	LateExcused = 'late-excused',
	LateNotExcused = 'late-not-excused',
	NotSelected = 'not-selected',
}

export class AttendanceRecord extends BaseModel {
	constructor(
		public id: number,
		public school_id: number,
		public activity_instance_id: number,
		public attendance_user: User,
		public created_at: Date,
		public updated_at: Date,
		public state: AttendanceRecordState,
		public check_in_time?: Date,
		public check_out_time?: Date,
		public checked_out_by_id?: number
	) {
		super();
	}

	static fromJSON(json: Record<string, any> | null): AttendanceRecord | null {
		if (!json) {
			return null;
		}

		const id = json.id,
			school_id = json.school_id,
			activity_instance_id = json.activity_instance_id,
			attendance_user = User.fromJSON(json.attendance_user),
			created_at = new Date(json.created_at),
			updated_at = new Date(json.updated_at),
			state = json.state,
			check_in_time = json.check_in_time ? new Date(json.check_in_time) : undefined,
			check_out_time = json.check_out_time ? new Date(json.check_out_time) : undefined,
			checked_out_by_id = json.checked_out_by_id;

		if (!attendance_user) {
			return null;
		}

		return new AttendanceRecord(
			id,
			school_id,
			activity_instance_id,
			attendance_user,
			created_at,
			updated_at,
			state,
			check_in_time,
			check_out_time,
			checked_out_by_id
		);
	}
}
